import { useMemo } from 'react';
import { type SWRResponse } from 'swr';

import { type SwrKey, type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/filing-review/creators/{creatorId}/configs']['GET'];
type Input = ThisApi['params'] & ThisApi['query'];
type Output = ThisApi['response'];

export const useCreatorFilingReviewConfigs = (
  params: Input | null,
  config?: UseNoodleSwrConfig<Output>,
): SWRResponse<Output> => {
  const key = useMemo((): SwrKey => {
    if (!params) return null;
    const { creatorId, ...query } = params;
    const path = buildPath<ThisApi>('/filing-review/creators/{creatorId}/configs', { creatorId });
    return [path, { params: query }];
  }, [params]);

  return useNoodleSwr<Output>(key, { revalidateOnFocus: false, ...config });
};

const listCreatorConfigs = async (params: Input): Promise<Output> => {
  const { creatorId, ...query } = params;
  const path = buildPath<ThisApi>('/filing-review/creators/{creatorId}/configs', { creatorId });
  const response = await noodleApiClient.get(path, { params: query });
  return response.data;
};

export default listCreatorConfigs;
